import { render, staticRenderFns } from "./ImageExamStatusLabel.vue?vue&type=template&id=3d060a31&scoped=true&"
import script from "./ImageExamStatusLabel.vue?vue&type=script&lang=js&"
export * from "./ImageExamStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./ImageExamStatusLabel.vue?vue&type=style&index=0&id=3d060a31&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d060a31",
  null
  
)

export default component.exports